import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../Modals/Confirm';

export function ConfirmDeleteOperatorModal(props) {
    return (
        <ConfirmModal 
            isOpen={props.isOpen}
            toggle={props.toggle} 
            handleConfirm={(e) => props.handleConfirm(props.operator, e)}
            title="Delete Operator?"
            confirmText="Yes, Delete Operator"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following Operator?</strong>
            </Alert>

            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-xs-12">Full Name</th>                      
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.operator.firstName} {props.operator.surname}</td>
                    </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}